import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { numPagesDisplayed } from '../../../consts';

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.css'],
    standalone: false
})
export class PaginatorComponent implements OnInit, OnChanges {

  @Output() changePage = new EventEmitter<any>(true); 
  @Input() actualPage = 1;
  @Input() totalPages = 1;
  
 
  pages: number[]; 

  constructor() { }

  showFirstPages(){
    for (let i = 1; i <= this.totalPages; i++) { 
      if(i <= this.totalPages){  
        this.pages.push(i); 
      }
      if (i==numPagesDisplayed)
        i = this.totalPages + 1;
    }
  }

  showLastPages(){
    for (let i = this.totalPages; i >= this.totalPages - numPagesDisplayed + 1; i--) {
      if(i > 0){ 
        this.pages.unshift(i); 
      } 
      if (i==1)
        i = 0;
    }
  }

  showMiddlePages(){ 
    const mid = Math.floor(numPagesDisplayed/2); 
    
    //añadimos las anteriores 
    for (let i = this.actualPage - mid; i <  this.actualPage; i++) { 
      if(i > 0){
        this.pages.push(i); 
      }
    }

    //añadimos la actual y las siguientes  
    for (let i = this.actualPage ; i <=  this.actualPage + mid; i++) {
      if(i <= this.totalPages){ 
        this.pages.push(i); 
      }
    }

  }

  ngOnInit() {  
    this.pages = [];
    if (this.actualPage == 1){ 
      this.showFirstPages();
    }else{ 
      if (this.actualPage == this.totalPages){
        this.showLastPages();  
      }else{ 
        this.showMiddlePages(); 
      }
    }

    this.setPage(this.actualPage); 
  }

  ngOnChanges(changes: SimpleChanges) { 
  }

  private setPage(page: number) {
    if (page != this.actualPage){ 
      this.actualPage = page; 
      this.changePage.emit(page);
    }
  }

  public trackByIndex(i: number) { return i; }

}

 
 

 
  